import http from 'core/services/http';
import axios from 'axios';
import Config from 'core/config';

class LocationService {
  static createLocation(location) {
    return http.post(`${Config.apiUrl}/location`, location);
  }

  static updateLocation(location) {
    if (location.id) {
      return http.put(`${Config.apiUrl}/location`, location);
    }
    return http.post(`${Config.apiUrl}/location`, location);
  }

  static deleteLocation(location) {
    return http.delete(`${Config.apiUrl}/location/${location.id}`);
  }

  static getLocation(locationId) {
    return http.get(`${Config.apiUrl}/location/${locationId}`);
  }

  static getLocationsByTestCenter(testCenterId) {
    return http.get(`${Config.apiUrl}/location/${testCenterId}/testcenter`);
  }

  static updateLocations(locations) {
    return axios.all(locations.map(location => this.updateLocation(location)));
  }
}

export default LocationService;
